import { CalendarIcon } from "lucide-react";
import { useState } from "react";

import {
  Calendar,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Button,
} from "@repo/ui";

const now = new Date();
const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

const selectedDates = [];

export function MultiSelectDatePicker({ dates, setDates, placeholder }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline">
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dates && dates.length > 0 ? (
            `${dates.length} date${dates.length > 1 ? "s" : ""} selected`
          ) : (
            <span>{placeholder || "Pick dates"}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0">
        <Calendar mode="multiple" onSelect={setDates} selected={dates} />
      </PopoverContent>
    </Popover>
  );
}
